import { useEffect, useState } from 'react'
import { getSegmentos } from '../services/ClientServices/getClientService'
import { getCategorias } from '../services/ProductService/getProducts'

interface OpcoesFiltrosCatalogo {
  /** Buscar tambem as categorias de material. Falso na tela de Clientes, que so filtra por segmento. */
  comCategorias?: boolean
}

/**
 * Opcoes dos filtros de Segmento (do cliente) e Categoria de material, usados nas telas de
 * Predicao, Clientes e Vendas.
 *
 * As duas listas vem prontas do backend (sem repetidos, ordenadas e ja restritas ao escopo do
 * usuario logado), entao aqui nao ha nenhum tratamento: o valor exibido e exatamente o valor
 * enviado de volta no filtro. E o que garante que a opcao escolhida sempre casa com as linhas
 * filtradas — diferente dos selects de Cliente/Produto, que exibem nome e convertem para id.
 *
 * Chame-o no COMPONENTE da tela, nao dentro do hook dela: usePrediction e useSales sao montados
 * mais de uma vez por pagina (o SelectCompanie chama useSales; o Dashboard chama usePrediction so
 * para pegar a data de hoje), e o catalogo acabaria sendo buscado por quem nao o usa.
 *
 * Falha na busca nao mostra toast: o filtro e acessorio e um erro aqui nao pode atrapalhar a tela.
 * A lista fica vazia e o filtro simplesmente nao oferece opcoes.
 */
export const useFiltrosCatalogo = ({
  comCategorias = true,
}: OpcoesFiltrosCatalogo = {}) => {
  const [segmentos, setSegmentos] = useState<string[]>([])
  const [categorias, setCategorias] = useState<string[]>([])
  const [carregandoCatalogo, setCarregandoCatalogo] = useState(true)

  useEffect(() => {
    let ativo = true
    const buscar = async () => {
      const [resultSegmentos, resultCategorias] = await Promise.all([
        getSegmentos(),
        comCategorias ? getCategorias() : Promise.resolve([] as string[]),
      ])
      if (!ativo) return
      if (Array.isArray(resultSegmentos)) setSegmentos(resultSegmentos)
      if (Array.isArray(resultCategorias)) setCategorias(resultCategorias)
      setCarregandoCatalogo(false)
    }
    buscar()
    return () => {
      ativo = false
    }
  }, [comCategorias])

  return { segmentos, categorias, carregandoCatalogo }
}
